<template>
  <div>
    <el-form
      :model="form"
      label-width="80px"
      :inline="true"
      class="demo-form-inline"
      id="form"
    >
      <el-row :gutter="gutter">
        <el-col :span="20" :offset="1">
          <el-col :span="8" class="label"> 登录帐号： </el-col>
          <el-col :span="14">
            <el-input v-model="form.username"></el-input>
          </el-col>
        </el-col>
      </el-row>
      <el-row :gutter="gutter">
        <el-col :span="20" :offset="1">
          <el-col :span="8" class="label"> 用户姓名： </el-col>
          <el-col :span="14">
            <el-input v-model="form.name"></el-input>
          </el-col>
        </el-col>
      </el-row>
      <el-row :gutter="gutter">
        <el-col :span="20" :offset="1">
          <el-col :span="8" class="label"> 联系方式： </el-col>
          <el-col :span="14">
            <el-input v-model="form.phone"></el-input>
          </el-col>
        </el-col>
      </el-row>
      <el-row :gutter="gutter">
        <el-col :span="20" :offset="1">
          <el-col :span="8" class="label"> 二维码： </el-col>
          <el-col :span="14">
            <uploadImage
          @setImgFun="getImgUrl"
          :fileListArr.sync="form.qr_code"
        ></uploadImage>
          </el-col>
        </el-col>
      </el-row>
      
      <el-row :gutter="gutter">
        <el-col :span="20" :offset="1">
          <el-col :span="8" class="label"> 角色： </el-col>
          <el-col :span="14">
            <el-select v-model="form.role_id" placeholder="请选择">
              <el-option
                v-for="(item,index) of options"
                :key="index"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-col>
      </el-row>
      <el-row :gutter="gutter">
        <el-col :span="20" :offset="1">
          <el-col :span="8" class="label"> 登陆密码： </el-col>
          <el-col :span="14">
            <el-input
              v-model="form.password"
              type="password"
              :placeholder="place"
            ></el-input>
          </el-col>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5" :offset="8">
          <el-button type="primary" @click="sub()"> 确定 </el-button>
        </el-col>
        <el-col :span="5" :offset="3">
          <el-button type="primary" @click="close()"> 取消 </el-button>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import uploadImage from "../../components/upload-image/upload-image";
export default {
  name: "user",
  props: ["editrow", "roleList"],
  components:{uploadImage},
  data() {
    return {
      gutter: 20,
      form: {},
      place: "提示：默认密码为123456a",
      options: [],
      modify:0,
    };
  },
  created() {
    let options = [];
    for (let i = 0; i < this.roleList.length; ++i) {
      options.push({
        value: this.roleList[i].id,
        label: this.roleList[i].name,
      });
    }
    this.options = options;
    if (this.editrow) {
      this.form = this.editrow;
      //this.form.is_admin = this.edit.is_admin.toString();
    }
  },
  mounted(){
    console.log("多次调用")
  },
  methods: {
    // 获得图片上传路径
    getImgUrl(e) {
      this.form.qr_code = JSON.stringify(e); //上传文件列表
    },
    sub() {
       let obj = {
        static:false
      }
      if(!this.form.password){
        this.form.password = "123456a"
      }
      if(this.form.name && this.form.username && this.form.phone && this.form.role_id  && this.form.password){
        obj.form = this.form
      }else{
        this.$message.error("这些都是必选项");
        return
      }
      this.$emit("userEmit", obj);
      this.form = {}
    },
    close() {
      let obj = {
        static:false
      }
      this.$emit("userEmit", obj);
      this.form = {}
    },
  },
};
</script>

<style scoped lang="scss">
#form {
  .el-col {
    min-height: 40px;
    .el-date-editor {
      width: 100%;
    }
    .label {
      color: #5f6165;
      height: 40px;
      line-height: 38px;
      text-align: right;
      font-size: 14px;
    }
    .el-radio-group {
      margin-top: 14px;
      float: left;
    }
    .ty {
      text-align: left;
      border-radius: 5px;
      background-color: #e2b837;
      height: 50px;
      line-height: 3.5;
    }
  }
  .el-row {
    min-height: 30px;
    margin-bottom: 22px;
  }
  .el-select {
    width: 100%;
  }
}
</style>
